export const Types = {
  Button: "Button",
  Custom: "Custom",
  Text: "Text",
  Image: "Image",
  Input: "Input",
  Video: "Video",
  Event: "Event",
  Gallery: "Gallery",
  Feed: "Feed",
  NewsletterItem: "NewsletterItem",
  Links: "Links",
  Link: "Link",
  Icons: "Icons",
  Icon: "Icon",
  Null: "Null"
}
